export default __webpack_public_path__ + "static/home-background-lg-e2b37601ef3c5d96f8c28d26766508f4.jpg";